import css from 'styled-jsx/css';

const styles = css.global`body {
    height: calc(100vh - 80px)!important;
    background: #EC0000;
}

.embed-sim {
    width: 100%;
    height: 100%;
    position: relative;
    max-width: 992px;
    margin: auto;
}

.embed-sim .embed-sim-iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    border: none;
}

div[class=ion-page] {
    overflow: auto !important;
}`;

export default styles;